/*
   본 소프트웨어는 관련 법률에 따라 보호되는 삼성의 지식재산 및 영업비밀 입니다. 본 소프트웨어를 권한 없이 사용하거나 삼성의 사전 서면 동의 없이 제3자에게 공개하는 행위는
   엄격히 금지되어 있으며 위반 시 귀하는 무단 사용 또는 비밀 유지 의무 위반에 대해 법적인 책임을 져야 합니다. This software is the intellectual
   property and confidential information of Samsung Electronics, Co., Ltd. (“Samsung”) protected by
   applicable laws. The unauthorized use or disclosure of the software to any third party without
   the prior written consent of Samsung is strictly prohibited, and you should be legally
  responsible for the unauthorized use or violation of confidentiality obligation.
*/
// date 관련 유틸리티
import moment from 'moment';
import _ from 'lodash';
import SDLUtil from '@/utils/SDLUtil';

/**
 * 현재 날짜 (locale 별 format)
 * @returns {*}
 */
const now = () => moment().format(SDLUtil.getMsgProp('data-format.date.ymd'));

/**
 * 날짜 기준 이후 데이터
 * @param num 더해지는 수치
 * @param unit 더해지는 항목 ex) 년: Y, 월: M, 일: D
 * @param date 기준 날짜 (기본값 - 현재)
 * @returns {string}
 */
const addDate = (num, unit, date = moment()) => moment(date)
  .add(num, unit)
  .format(SDLUtil.getMsgProp('data-format.date.ymd'));

/**
 * 날짜 기준 이전 데이터
 * @param num 빼지는 수치
 * @param unit 빼지는 항목 ex) 년: Y, 월: M, 일: D
 * @param date 기준 날짜 (기본값 - 현재)
 * @returns {string}
 */
const subDate = (num, unit, date = moment()) => moment(date)
  .subtract(num, unit)
  .format(SDLUtil.getMsgProp('data-format.date.ymd'));

/**
 * 표준 포맷으로 변환
 * @param param 날짜 데이터  (String / Object)
 * @param format 날짜 포맷 (ex. YYYY-MM-DD)
 * @returns {string|{endDate: string, startDate: string}}
 */
const stdFormat = (param, format = 'YYYY-MM-DD') => {
  let result = null;
  if (_.has(param, 'startDate')) {
    result = {
      startDate: moment(param.startDate).format(format),
      endDate: moment(param.endDate).format(format),
    };
  } else {
    result = moment(param).format(format);
  }
  return result;
};

export default {
  now,
  addDate,
  subDate,
  stdFormat,
};



// WEBPACK FOOTER //
// ./src/utils/DateUtil.js